export default __webpack_public_path__ + "static/media/oscer-pres-urinary-incontinence.9ca00ec2.svg";